import React from "react";
import { withRouter } from "react-router";

const IssuingRejected = ({ history }) => {
  return (
    <div className="flex flex-col items-center justify-center">
      <div className="text-2xl">
        Sorry, your application was not accepted at this time
      </div>
    </div>
  );
};

export default withRouter(IssuingRejected);
